import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import "./index.css";
import ApiServices from "../../services/apiServices";
import { useLoad } from "../../context/Load";
import storage from "../../services/storage";
import ForcaSenha from "../../Components/ForcaSenha";
import Mask from "../../services/mask";
import Checkbox from "../../Components/Checkbox";
import moment from "moment";

export default function ConfigAcoesNovoEditar() {
  const [validacao, setValidacao] = useState(false);
  const [verImagem, setVerImagem] = useState("");
  const [verPdf, setVerPdf] = useState("");
  const [arquivoFile, setArquivoFile] = useState(null);
  const [arquivoFilePdf, setArquivoFilePdf] = useState(null);
  const [periodoAtividade, setPeriodoAtividade] = useState([
    { periodoAtividadeId: "0", nome: "Indeterminado" },
    { periodoAtividadeId: "1", nome: "Determinado" },
  ]);
  const [acao, setAcao] = useState({
    nome: "",
    periodoAtividade: "",
    dataInicio: "",
    dataFim: "",
    status: "ativo",
    gerente: false,
    vendedor: false,
    descricao: "",
    role: [],
    conteudo: "",
    imagemAnexada: "",
    pdf: "",
  });
  const { load, setLoad } = useLoad();
  const navigate = useNavigate();
  const params = useParams();

  const userName = storage.get("USUARIO").profile.userName;

  async function fnRoleParticipante() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet(`role/participante`);

      response.data.forEach((e) => {
        e.status = true;
      });
      if (params.id) {
        fnAcoesBuscar(response.data);
      }
      if (response.statusCode == 200) {
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnAcoesBuscar() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet(`noticia/` + params.id);
      setAcao((prev) => ({
        ...prev,
        nome: response.data.nome,
        celular: response.data.phoneNumber,
        email: response.data.email,
        status: response.data.ativo ? "ativo" : "inativo",
        dataInicio: moment(response.data.dataInicio).format("YYYY-MM-DD"),
        dataFim: moment(response.data.dataFim).format("YYYY-MM-DD"),
        descricao: response.data.descricao,
        conteudo: response.data.conteudo,
        periodoAtividade: String(response.data.periodo),
      }));
      var temp = [];

      setVerImagem(response.data.urlImagem);
      setVerPdf(response.data.urlImagem);
      // setVerPdf(response.data.pdf);

      if (response.statusCode == 200) {
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnAcaoNovo() {
    try {
      var objEnvio = {
        nome: acao.nome,
        periodoIndeterminado: acao.periodoAtividade,
        dataInicio: acao.dataInicio || null,
        dataFim: acao.dataFim || null,
        ativo: acao.status == "ativo" ? true : false,
        roles: acao.role,
        descricao: acao.descricao,
        conteudo: acao.conteudo,
        urlImagem: acao.imagemAnexada,
        pdf: acao.pdf,
      };

      setLoad(true);
      let response = await ApiServices.apiPost(`noticia`, objEnvio);

      if (response.statusCode == 200) {
        toast.success("Notícia cadastrada");
        navigate("/comunicacao/noticia");
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnAcaoEditar() {
    var objEnvio = {
      nome: acao.nome,
      periodoIndeterminado: acao.periodoAtividade,
      dataInicio: acao.dataInicio || null,
      dataFim: acao.dataFim || null,
      ativo: acao.status == "ativo" ? true : false,
      roles: acao.role,
      descricao: acao.descricao,
      conteudo: acao.conteudo,
      urlImagem: acao.imagemAnexada || verImagem,
      pdf: acao.pdf || verPdf,
    };

    try {
      setLoad(true);
      let response = await ApiServices.apiPut(`noticia/` + params.id, objEnvio);

      if (response.statusCode == 200) {
        toast.success("Notícia alterada");
        navigate("/comunicacao/noticia");
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnCarregarImagem(e) {
    try {
      const file = e.target.files[0];

      if (file) {
        const reader = new FileReader();

        reader.onload = function (e) {
          const image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            const larguraImagem = image.width;
            const alturaImagem = image.height;
            if (image.width !== 360 && image.height !== 360) {
              toast.warn("Imagem deve ter 360x360px");
            } else {
              setVerImagem(e.target.result);
              setLoad(false);

              const dataForm = new FormData();
              dataForm.append("file", file);
              setArquivoFilePdf(dataForm);
            }
          };
        };

        reader.readAsDataURL(file);
      } else {
      }
    } catch (err) {
      console.error("Erro ao fazer upload:", err);
    } finally {
    }
  }
  async function fnCarregarPdf(e) {
    try {
      const file = e.target.files[0];
  
      if (file) {
        // Validação de tipo e tamanho
        if (file.type !== "application/pdf") {
          toast.warn("Apenas arquivos PDF são aceitos.");
          return;
        }
  
        if (file.size > 10 * 1024 * 1024) {
          toast.warn("O arquivo deve ter no máximo 10 MB.");
          return;
        }
  
        const reader = new FileReader();
  
        reader.onload = function (e) {
          setVerPdf(e.target.result);
  
          const dataForm = new FormData();
          dataForm.append("file", file);
          setArquivoFilePdf(dataForm);
        };
  
        reader.readAsDataURL(file);
      }
    } catch (err) {
      console.error("Erro ao fazer upload:", err);
    }
  }
  async function fnEnviarImagemApi() {
    try {
      setLoad(true);
      let response = await ApiServices.apiUpload(`upload/noticia`, arquivoFile);

      setAcao((prev) => ({
        ...prev,
        imagemAnexada: response.data,
      }));
      fnEnviarPdf();
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnEnviarPdf() {
    try {
      setLoad(true);
      let response = await ApiServices.apiUpload(`upload/noticia`, arquivoFilePdf);

      setAcao((prev) => ({
        ...prev,
        pdf: response.data,
      }));
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    if (acao.imagemAnexada != "" && acao.pdf != "") {
      params.id ? fnAcaoEditar() : fnAcaoNovo();
    }
  }, [acao.imagemAnexada, acao.pdf]);

  useEffect(() => {
    fnRoleParticipante();
  }, []);


  useEffect(() => {
    if (acao.periodoAtividade == "0") {
      setAcao((prev) => ({ ...prev, dataInicio: "", dataFim: "" }));
    }
  }, [acao.periodoAtividade]);

  return (
    <div className="row">
      <div className="tituloPagina">
        {params.id ? "EDITAR NOTÍCIA" : "CADASTRO DE NOTÍCIA"}
      </div>
      <div className="subTituloPagina">Configuração geral</div>

      <div className="row">
        <div className="col-md-4 mt-3">
          <label>
            Nome<span style={{ color: "red", fontWeight: 900 }}>*</span>
          </label>
          <form autoComplete="off">
            <input
              autoComplete="off"
              className="form-control"
              type="text"
              value={acao.nome}
              onChange={(e) => {
                e.persist();
                setAcao((prev) => ({
                  ...prev,
                  nome: e.target.value,
                }));
              }}
            />
          </form>
          <div className="avisoCampo">
            {acao?.titulo?.length < 3 ? "Inserir título" : " "}
          </div>
        </div>
        <div className="col-md-2 mt-3">
          <label>
            Início<span style={{ color: "red", fontWeight: 900 }}>*</span>
          </label>
          <form autoComplete="off">
            <input
              autoComplete="off"
              className="form-control"
              type="date"
              value={acao.dataInicio || ""}
              disabled={acao.periodoAtividade === "0"}
              onChange={(e) => {
                e.persist();
                setAcao((prev) => ({
                  ...prev,
                  dataInicio: e.target.value,
                }));
              }}
            />
          </form>
          <div className="avisoCampo">
            {!acao.dataInicio && acao.periodoAtividade != "0"
              ? "Inserir data"
              : " "}
          </div>
        </div>
        <div className="col-md-2 mt-3">
          <label>
            Término<span style={{ color: "red", fontWeight: 900 }}>*</span>
          </label>
          <form autoComplete="off">
            <input
              autoComplete="off"
              className="form-control"
              type="date"
              value={acao.dataFim || ""}
              disabled={acao.periodoAtividade === "0"}
              onChange={(e) => {
                e.persist();
                setAcao((prev) => ({
                  ...prev,
                  dataFim: e.target.value,
                }));
              }}
            />
          </form>
          <div className="avisoCampo">
            {!acao.dataFim && acao.periodoAtividade != "0"
              ? "Inserir data"
              : " "}
          </div>
        </div>
        <div className="col-md-2 mt-3">
          <label>
            Tipo<span style={{ color: "red", fontWeight: 900 }}>*</span>
          </label>

          <select
            className="form-select"
            value={acao.periodoAtividade}
            onChange={(e) => {
              e.persist();
              setAcao((prev) => ({
                ...prev,
                periodoAtividade: e.target.value,
              }));
            }}
          >
            <option value="">Selecione</option>
            {periodoAtividade.map((e, i) => (
              <option value={e.periodoAtividadeId} key={i}>
                {e.nome}
              </option>
            ))}
          </select>
          <div className="avisoCampo">
            {!acao.periodoAtividade ? "Inserir tipo" : " "}
          </div>
        </div>
        <div className="col-md-2 mt-3">
          <label>
            Status<span style={{ color: "red", fontWeight: 900 }}>*</span>
          </label>

          <select
            className="form-select"
            value={acao.status}
            onChange={(e) => {
              e.persist();
              setAcao((prev) => ({
                ...prev,
                status: e.target.value,
              }));
            }}
          >
            <option value="ativo">Ativo</option>
            <option value="inativo">Inativo</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mt-3">
          <label>
            Descrição<span style={{ color: "red", fontWeight: 900 }}>*</span>
          </label>
          <form autoComplete="off">
            <input
              autoComplete="off"
              className="form-control"
              type="text"
              value={acao.descricao}
              onChange={(e) => {
                e.persist();
                setAcao((prev) => ({
                  ...prev,
                  descricao: e.target.value,
                }));
              }}
            />
          </form>
          <div className="avisoCampo">
            {acao?.descricao?.length < 3 ? "Inserir descrição" : " "}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 mt-3">
          <label>
          Como funciona<span style={{ color: "red", fontWeight: 900 }}>*</span>
          </label>
          <form autoComplete="off">
            <textarea
              autoComplete="off"
              className="form-control"
              rows={5}
              placeholder="Descreva aqui a mecânica da ação"
              type="text"
              value={acao.conteudo || ''}
              onChange={(e) => {
                e.persist();
                setAcao((prev) => ({
                  ...prev,
                  conteudo: e.target.value,
                }));
              }}
            />
          </form>
          <div className="avisoCampo">
            {acao?.conteudo?.length < 3 ? "Inserir descrição" : " "}
          </div>
        </div>
      </div>
      <div className="row">
      <div className="col-md-4">
        {verImagem ? (
          <button
            className="btn btn-danger my-3"
            style={{ width: 360 }}
            onClick={() => {
              setVerImagem("");
              setArquivoFile(null);
              document.querySelector(".inputUpload").value = "";
            }}
          >
            Excluir arte da ação
          </button>
        ) : (
          <button
            className="btn btn-primary my-3"
            style={{ width: 360 }}
            onClick={() => {
              document.querySelector(".inputUpload").click();
            }}
          >
           Importar arte da ação*
          </button>
        )}
        <input
          className="d-none inputUpload"
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          onChange={fnCarregarImagem}
        />
        <div style={{ fontSize: 12 }}>Formatos aceitos: jpeg, jpg, png</div>
        <div style={{ fontSize: 12 }}>Tamanho recomendado: 360 x 360 px</div>
        <div
          className="border"
          style={{ width: 360, height: 360, overflow: "hidden" }}
        >
          <img src={verImagem} alt="" />
        </div>
      </div>
      <div className="col-md-4">
  {verPdf ? (
    <button
      className="btn btn-danger my-3"
      style={{ width: 360 }}
      onClick={() => {
        setVerPdf("");
        setArquivoFilePdf(null);
        document.querySelector(".inputUploadpdf").value = "";
      }}
    >
      Excluir Regulamento
    </button>
  ) : (
    <button
      className="btn btn-primary my-3"
      style={{ width: 360 }}
      onClick={() => {
        document.querySelector(".inputUploadpdf").click();
      }}
    >
      Importar Regulamento*
    </button>
  )}
  <input
    className="d-none inputUploadpdf"
    type="file"
    accept="application/pdf"
    onChange={fnCarregarPdf}
  />
  <div style={{ fontSize: 12 }}>Formato aceito: PDF</div>
  <div style={{ fontSize: 12 }}>Tamanho máximo: 10 MB</div>
  <div
    className="border"
    style={{ width: 360, height: 360, overflow: "hidden" }}
  >
    {verPdf ? <embed src={verPdf} width="100%" height="100%" /> : null}
  </div>
</div>


      </div>
      <div className="row mt-5 d-flex justify-content-center mb-5">
        <div className="col-md-3 mt-2">
          <button
            className="btn btn-outline-primary w-100 "
            onClick={() => {
              navigate(-1);
            }}
          >
            VOLTAR
          </button>
        </div>
        <div className="col-md-3 mt-2">
          <button
            className="btn btn-primary w-100 "
            onClick={fnEnviarImagemApi}
            disabled={
              acao?.nome?.length < 3 ||
              acao.periodoAtividade == "" ||
              (!acao.dataFim && acao.periodoAtividade != "0") ||
              (!acao.dataInicio && acao.periodoAtividade != "0") ||
              !acao.role[0] ||
              acao?.descricao?.length < 3 ||
              !verImagem
            }
          >
            {params.id ? "ALTERAR" : "SALVAR"}
          </button>
        </div>
      </div>
    </div>
  );
}
